import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function A() {
    const { useLang } = useGlobal();
    const { t } = useLang('casestudy');
    return (
        <div className={`case-study-A ${css['case-study-A']}`}>
            <div className="secA-top">
                <div className="text-box">
                    <p className="title">{t('secA_title')}</p>
                    <p className="desc">{t('secA_desc')}</p>
                </div>
                <div className="img-box">
                    <NextImage
                        priority
                        webpSrc={require('@publicLocal/casestudy/pc/1.webp')}
                        src={require('@publicLocal/casestudy/pc/1.jpg')}
                        alt={t('secA_title')}
                        aria-label={t('secA_title')}
                    />
                </div>
            </div>
            <div className="secA-bottom">
                <p className="text">{t('secA_text')}</p>
            </div>
        </div>
    );
}
